import { Link } from 'react-router-dom';
import { connectWallet } from '../services/blockchain';
import { truncate, useGlobalState, setGlobalState } from '../store';

const Header = () => {
    const [connectedAccount] = useGlobalState('connectedAccount');


    const handleChangeNetwork = (e) => {

        const networkId = Number(e.target.value)
        setGlobalState('networkId', networkId);
        window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: `0x${networkId.toString(16)}` }]
        })
    }

    return (
        <nav className="w-4/5 flex flex-row md:justify-center justify-between items-center py-4 mx-auto">
            <div className="md:flex-[0.5] flex-initial justify-center items-center">
                <Link to="/" className="text-white">
                    <span className="px-2 py-1 font-bold text-3xl italic">SUNSHINE</span>
                    <span className="py-2 font-semibold italic">NFT-Market</span>
                </Link>
            </div>

            <ul className="md:flex-[0.2] text-white md:flex hidden list-none flex-col justify-between items-start flex-initial">
                <Link to="/" className="mx-1 cursor-pointer py-2">Gorgeous Lady</Link>
                <Link to="/collections" className="mx-1 cursor-pointer py-2">Gorgeous NFT Collection</Link>
            </ul>

            <ul className="md:flex-[0.2] text-white md:flex hidden list-none flex-col justify-between items-start flex-initial">
                <a href="https://sunshine-nft-market1.vercel.app" target="_self" className="mx-3 cursor-pointer py-2">Muscular Guy</a>
                <a href="https://sunshine-nft-market1.vercel.app/collections" target="_self" className="mx-3 cursor-pointer py-2">Muscular NFT Collection</a>
            </ul>


            <ul className="md:flex-[0.5] text-white md:flex hidden list-none flex-row justify-between items-center flex-initial">
                <a href="https://sunshine-nft-market2.vercel.app" target="_self" className="mx-4 cursor-pointer py-2">Public Market</a>
                <a href="https://sunshine-nft-market2.vercel.app/collections" target="_self" className="mx-4 cursor-pointer py-2">Public Collection</a>
                <li className="flex mx-4 cursor-pointer items-center">
                    <select
                        className="z-8 w-26 p-2 text-black bg-white border rounded-lg shadow-md bg-green-300"
                        onChange={handleChangeNetwork}
                        style={{ fontSize: '0.5rem' }}
                    >
                        <option value="314159">File - Calibration </option>
                        <option value="11155111">Sepolia Testnet</option>
                        <option value="5">Goerli Testnet</option>
                    </select>
                </li>
            </ul>


            {connectedAccount ? (
                <button className="shadow-xl shadow-black text-white bg-green-500 hover:bg-green-700 md:text-xs p-2 rounded-full cursor-pointer text-xs sm:text-base">
                    {truncate(connectedAccount, 4, 4, 11)}
                </button>
            ) : (
                <button className="shadow-xl shadow-black text-white bg-green-500 hover:bg-green-700 md:text-xs p-2 rounded-full cursor-pointer text-xs sm:text-base" onClick={connectWallet}>
                    Connect Wallet
                </button>
            )}
        </nav>
    );
};

export default Header;
